<template>
  <div class="payment-confirm-page">
    <sub-header-section :pageTitle="$tc('PaymentPage.EditPage.pageTitle')" />
    <payment-confirm-pane />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import PaymentConfirmPane from '@/components/pc/MyPage/PaymentPage/PaymentConfirmPane.vue'

/**
 * クレジットカード情報変更ページ
 */
export default defineComponent({
  name: 'PaymentConfirmPage',
  components: {
    SubHeaderSection,
    PaymentConfirmPane,
  },
})
</script>

<style lang="scss" scoped>
.payment-confirm-page {
  &__header {
    position: sticky;
    top: 0;
  }
}
</style>
